module.exports = __webpack_public_path__ + "165460e2f9375b7bedf4572db57b37be.svg";